import {
    FETCH_ACCOUNT_TYPES_METRICS_REQUEST,
    FETCH_ACCOUNT_TYPES_METRICS_SUCCESS,
    FETCH_ACCOUNT_TYPES_METRICS_FAILURE,
    FETCH_NEW_ACCOUNTS_METRICS_REQUEST,
    FETCH_NEW_ACCOUNTS_METRICS_SUCCESS,
    FETCH_NEW_ACCOUNTS_METRICS_FAILURE,
    CLEAR_DATA_METRICS_ERRORS
} from './DataMetricsTypes';

const initialState = {
    loading: true,
    error: null,
    accountTypes: {
        loading: false,
        data: {},
        error: null
    },
    newAccounts: {
        loading: false,
        data: {
            newAccounts30Days: 0,
            newAccounts90Days: 0,
            newAccountsOneYear: 0,
            accountTypeBreakdown30Days: {},
            accountTypeBreakdown90Days: {},
            accountTypeBreakdownOneYear: {}
        },
        error: null
    },
};

const dataMetricsReducer = (state = initialState, action) => {
    switch (action.type) {
        // Account Types Metrics
        case FETCH_ACCOUNT_TYPES_METRICS_REQUEST:
            return {
                ...state,
                accountTypes: {
                    ...state.accountTypes,
                    loading: true,
                    error: null
                }
            };

        case FETCH_ACCOUNT_TYPES_METRICS_SUCCESS:
            return {
                ...state,
                accountTypes: {
                    ...state.accountTypes,
                    loading: false,
                    data: action.payload,
                    error: null
                }
            };

        case FETCH_ACCOUNT_TYPES_METRICS_FAILURE:
            return {
                ...state,
                accountTypes: {
                    ...state.accountTypes,
                    loading: false,
                    error: action.payload
                }
            };

        // New Accounts Metrics
        case FETCH_NEW_ACCOUNTS_METRICS_REQUEST:
            return {
                ...state,
                newAccounts: {
                    ...state.newAccounts,
                    loading: true,
                    error: null
                }
            };

        case FETCH_NEW_ACCOUNTS_METRICS_SUCCESS:
            return {
                ...state,
                newAccounts: {
                    ...state.newAccounts,
                    loading: false,
                    data: action.payload,
                    error: null
                }
            };

        case FETCH_NEW_ACCOUNTS_METRICS_FAILURE:
            return {
                ...state,
                newAccounts: {
                    ...state.newAccounts,
                    loading: false,
                    error: action.payload
                }
            };

        // Clear Errors
        case CLEAR_DATA_METRICS_ERRORS:
            return {
                ...state,
                error: null,
                accountTypes: {
                    ...state.accountTypes,
                    error: null
                },
                newAccounts: {
                    ...state.newAccounts,
                    error: null
                },
                comprehensive: {
                    ...state.comprehensive,
                    error: null
                },
                totalLoggedHours: {
                    ...state.totalLoggedHours,
                    error: null
                }
            };

        default:
            return state;
    }
};

export default dataMetricsReducer;